import { ColumnsType } from 'antd/es/table/Table';
import { Routes } from 'config/routes';
import { DonorOutput, DonorListSort } from 'gql/types';
import { Link } from 'modules/common/components';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('owner.EditOwnerProfileForm.DonorsTable');

export const columns: ColumnsType<DonorOutput> = [
  {
    title: t('petName'),
    render: (donor: DonorOutput) => (
      <Link
        to={`${Routes.DonorsProfile.replace(':id', String(donor.shortId))}`}
      >
        {donor.name}
      </Link>
    ),
    key: DonorListSort.Name,
  },
];
